import React from "react";
import * as RadixPopover from "@radix-ui/react-popover";
import { styled } from "../stitches.config";
import { Button, ButtonForwardRef } from "./Button";
import { IconType } from "./Icon";

export interface Props extends RadixPopover.PopoverOwnProps {
  label: string;
  icon?: IconType;
  ariaLabel?: string;
  title?: string;
}

export default function Popover({
  children,
  icon,
  ariaLabel,
  title,
  label,
  ...props
}: React.PropsWithChildren<Props>) {
  return (
    <RadixPopover.Root {...props}>
      <RadixPopover.Trigger
        as={ButtonForwardRef}
        icon={icon}
        aria-label={ariaLabel}
      >
        {label}
      </RadixPopover.Trigger>
      <Content>
        {title && <Title>{title}</Title>}
        {children}
        <SpacerArrow />
      </Content>
    </RadixPopover.Root>
  );
}

const Title = styled("h3", {
  color: "$menuTitleGray",
  fontWeight: "$medium",
  fontSize: "$3",
});

// Adds spacer between popover and trigger
export const SpacerArrow = styled(RadixPopover.Arrow, {
  opacity: 0,
  height: "$3",
});

export const Close = ({
  children,
  secondary,
}: React.PropsWithChildren<{ secondary?: boolean }>) => (
  <RadixPopover.Close
    as={Button}
    size="large"
    color={secondary ? "secondary" : "primary"}
  >
    {children}
  </RadixPopover.Close>
);

const Content = styled(RadixPopover.Content, {
  padding: "$4",
  borderRadius: "$2",
  border: "1px solid white",
  background: "$menuBeige",
  cursor: "default",
  maxWidth: "16rem",
  display: "grid",
  gridGap: "$4",
});
